import { render, staticRenderFns } from "./WsDes.vue?vue&type=template&id=e9ffb22c&"
import script from "./WsDes.vue?vue&type=script&lang=js&"
export * from "./WsDes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports